// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blocked-captcha__message[data-v-02a46396]{color:#ff5564;font-size:11px}.blocked-captcha__message .blocked-captcha__cookies-trigger[data-v-02a46396]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
